import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as content from '@/api/content.api';

export function useHomeStats() {
  return useQuery({ queryKey: ['home-stats'], queryFn: () => content.getHomeStats() });
}

export function useEvents() {
  return useQuery({ queryKey: ['events'], queryFn: () => content.getEvents() });
}

export function useEvent(slug: string) {
  return useQuery({ queryKey: ['event', slug], queryFn: () => content.getEvent(slug), retry: false });
}

export function useEventSignup(slug: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => content.signupEvent(slug),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['event', slug] }),
  });
}

export function useBundles() {
  return useQuery({ queryKey: ['bundles'], queryFn: () => content.getBundles() });
}

export function usePromos() {
  return useQuery({ queryKey: ['promos'], queryFn: () => content.getPromos() });
}

export function useCentres() {
  return useQuery({ queryKey: ['centres'], queryFn: () => content.getCentres() });
}

export function useArticles(cat: string | null) {
  return useQuery({ queryKey: ['articles', cat], queryFn: () => content.getArticles(cat) });
}

export function useArticle(slug: string) {
  return useQuery({ queryKey: ['article', slug], queryFn: () => content.getArticle(slug), retry: false });
}

export function useResources() {
  return useQuery({ queryKey: ['resources'], queryFn: () => content.getResources() });
}

export function useResourceDownload() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (slug: string) => content.downloadResource(slug),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['resources'] }),
  });
}

export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => content.getNotifications(),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
